import { styled } from "@mui/material/styles";
import { TableCell, TextField } from "@mui/material";

// Optimized readonly text field with simplified selectors
export const StyledReadonlyTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    alignItems: 'center',
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
      outline: 'none',
    },
  },
  '& .MuiInputBase-input': {
    textAlign: 'left',
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
});

// Optimized edit text field with simplified selectors
export const StyledEditTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    alignItems: 'center',
    '& fieldset': {
      border: '1px solid rgba(0, 0, 0, 0.23)',
    },
    '&:hover fieldset': {
      border: '2px solid rgba(0, 0, 0, 0.87)',
    },
    '&.Mui-focused fieldset': {
      border: '2px solid #1976d2',
    },
  },
  '& .MuiInputBase-input': {
    textAlign: 'left',
  },
});

// Simplified table cell with consolidated styles
export const StyledTableCell = styled(TableCell)({
  verticalAlign: 'middle',
  textAlign: 'left',
  '&.MuiTableCell-head': {
    fontWeight: 'bold',
  },
  '& .MuiFormControl-root': {
    alignItems: 'center',
    height: '100%',
  },
  '& .MuiSelect-select': {
    textAlign: 'left',
  },
});
